<script>
	import { onDestroy } from "svelte";
	import { Loading, Button } from "carbon-components-svelte";

	// Custom Methods
	import { handleExpenses, validateData } from "../../methods/handleExpense.js";

	// Custom Components

	// Stores
	import { ExpenseStore, BankStore, UserStore } from "../../store";

	let uid;

	// Input field's values Variables
	let expenseFormData = {
		expenseTitle: "",
		expenseCatagory: undefined,
		expenseAmount: undefined,
		selectedBank: undefined,
		expenseDate: undefined,
	};
	let validationProps = {
		titleEmpty: false,
		catagoryEmpty: false,
		amountEmpty: false,
		bankEmpty: false,
		dateEmpty: false,
	};

	// Stores
	const unsubUserStore = UserStore.subscribe((data) => {
		uid = data.uid;
	});

	// Methods

	const setLoadingState = (loadingState) => {
		ExpenseStore.update((data) => {
			data.loading = loadingState;
			return data;
		});
	};

	const callHandleExpense = () => {
		validateData(expenseFormData)
			.then((result) => {
				if (result.validation) {
					validationProps = {
						titleEmpty: false,
						catagoryEmpty: false,
						amountEmpty: false,
						bankEmpty: false,
						dateEmpty: false,
					};
					setLoadingState(true);

					handleExpenses(expenseFormData, uid, ExpenseStore, BankStore).then(
						(response) => {
							if (response.dataSaved) {
								setLoadingState(false);
								expenseFormData = {
									expenseTitle: "",
									expenseCatagory: undefined,
									expenseAmount: undefined,
									selectedBank: undefined,
									expenseDate: undefined,
								};
							}
						}
					);
				}
			})
			.catch((err) => {
				validationProps = {
					titleEmpty: false,
					catagoryEmpty: false,
					amountEmpty: false,
					bankEmpty: false,
					dateEmpty: false,
				};
				validationProps[`${err.field}`] = true;
				console.log("err = ", err.msg);
			});
	};

	// Life-cycle Methods

	onDestroy(() => {
		unsubUserStore();
	});
</script>

<div class="modal-content bg-light">
	{#if $ExpenseStore.loading}
		<Loading />
	{/if}
	<!-- Header -->
	<div class="modal-header border-0">
		<h5 class="modal-title text-secondary">Add Expense</h5>
		<button
			type="button"
			class="close text-dark"
			data-dismiss="modal"
			aria-label="Close">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>

	<!-- Body -->
	<div class="modal-body">
		<!-- Add Expense - Form -->
		<form>
			<div class="form-row">
				<!-- Expense Title - Input -->
				<div class="form-group col-12 col-md">
					<label for="expenseTitle">Expense Title</label>
					<input
						type="text"
						class="form-control"
						class:is-invalid={validationProps.titleEmpty}
						id="expenseTitle"
						aria-describedby="emailHelp"
						placeholder="Enter Product, Investment or Person's name."
						bind:value={expenseFormData.expenseTitle} />
					<div
						class="invalid-feedback"
						class:d-none={!validationProps.titleEmpty}>
						Expense Title is Required
					</div>
				</div>

				<!-- Expense Catagory/Type - Select -->
				<div class="form-group col-12 col-md">
					<label for="expenseCatagory">Expense Catagory/Type</label>
					<select
						class="custom-select"
						class:is-invalid={validationProps.catagoryEmpty}
						id="expenseCatagory"
						bind:value={expenseFormData.expenseCatagory}>
						<option value={undefined} selected>
							Select Expense Catagory/Type
						</option>
						<option value="Grocery">Grocery</option>
						<option value="Pets">Pets</option>
						<option value="Electrical Equipment">Electrical Equipments</option>
						<option value="Utility Bills">Utility Bills</option>
						<option value="Vegetables">Vegetables</option>
						<option value="Fruits">Fruits</option>
						<option value="Food">Food (Raw)</option>
						<option value="Food">Food (Cooked)</option>
						<option value="Snacks">Snacks</option>
						<option value="Construction Materials">
							Construction Materials
						</option>
						<option value="Home Accessories">Home Accessories</option>
						<option value="Kitchen Utensils">Kitchen Utensils</option>
						<option value="Home Maintenance">Home Maintenance</option>
						<option value="Medicine">Medicine</option>
						<option value="Telecom">Telecom</option>
						<option value="Tech/Gadgets">Tech/Gadgets</option>
						<option value="Others">Others</option>
					</select>
					<div
						class="invalid-feedback"
						class:d-none={!validationProps.titleEmpty}>
						Expense Title is Required
					</div>
				</div>
			</div>

			<div class="form-row">
				<!-- Expense Amount - Input -->
				<div class="form-group col-12 col-md">
					<label for="expenseAmount">Expense Amount</label>
					<input
						type="number"
						class="form-control"
						class:is-invalid={validationProps.amountEmpty}
						id="expenseAmount"
						aria-describedby="Expense Amount"
						placeholder="Enter the amount."
						bind:value={expenseFormData.expenseAmount} />
					<div
						class="invalid-feedback"
						class:d-none={!validationProps.amountEmpty}>
						Expense Amount is Required
					</div>
				</div>

				<!-- Banks - Radio Btns -->
				<div class="form-group col-12 col-md">
					<label for="expenseCatagory">Banks</label>
					<div
						class="custom-control custom-radio"
						class:is-invalid={validationProps.bankEmpty}>
						<input
							type="radio"
							id="monthlyBank"
							name="bankRadio"
							class="custom-control-input"
							class:is-invalid={validationProps.bankEmpty}
							bind:group={expenseFormData.selectedBank}
							value="monthlyBank"
							required />
						<label
							class="custom-control-label"
							class:is-invalid={validationProps.bankEmpty}
							for="monthlyBank">Monthly Bank</label>
					</div>
					<div
						class="custom-control custom-radio"
						class:is-invalid={validationProps.bankEmpty}>
						<input
							type="radio"
							id="reserveBank"
							name="bankRadio"
							class="custom-control-input"
							class:is-invalid={validationProps.bankEmpty}
							bind:group={expenseFormData.selectedBank}
							value="reserveBank"
							required />
						<label
							class="custom-control-label"
							class:is-invalid={validationProps.bankEmpty}
							for="reserveBank">Reserve Bank</label>
					</div>
					<div
						class="invalid-feedback"
						class:d-none={!validationProps.bankEmpty}>
						Bank is Required
					</div>
				</div>
			</div>

			<!-- Date - Select -->
			<div class="form-group w-50 pr-2">
				<label for="expenseDate">Date</label>
				<input
					type="date"
					class="form-control"
					class:is-invalid={validationProps.dateEmpty}
					id="expenseDate"
					bind:value={expenseFormData.expenseDate} />
				<div class="invalid-feedback" class:d-none={!validationProps.dateEmpty}>
					Expense Date is Required
				</div>
			</div>
		</form>
	</div>

	<!-- Footer -->
	<div class="modal-footer border-0">
		<button type="button" class="btn btn-dark" data-dismiss="modal">
			Close
		</button>
		<Button type="button" on:click={callHandleExpense}>Save changes</Button>
	</div>
</div>
